import { Alert, CircularProgress, FormControl, InputLabel, Modal, Snackbar, Box, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useForm, Controller, FormProvider } from "react-hook-form";
import useStateRef from "react-usestateref";
import { useDispatch, useSelector } from "react-redux";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../../components/Inputs/InputText"
import { style as modalStyle } from "../../../components/Loading/Loading";
import servEquipamentos from "../../../services/login/servEquipamentos";
import servParam from "../../../services/login/servParam";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import styles from "./Cadastro.module.css";
import { logout } from "../../../state/slices/userSlice";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { Geral } from "./Abas/Geral";
import { Documentos } from "./Abas/Documentos";
import Popup from "../../../components/Popup";
import { EquipamentoContext } from "../../../contexts/EquipamentoContext";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const valoresIniciais = {
    Id: 0,
    descricao: '',
    fabricante: '',
    modelo: '',
    fases: '',
    tipo: { value: 1, label: "Módulo" },
    possuiafci: {
        value: 0,
        label: "Não informado"
    },
    potencia: 0,
    tensaoFornecimento: {
        value: null,
        label: null
    },
    fabricanteCadastrado: {
        value: null,
        label: null
    }
}

const options = [
    { value: 0, label: "Não se aplica" },
    { value: 1, label: "Monofásica" },
    { value: 2, label: "Bifásica" },
    { value: 3, label: "Trifásica" }
];

const optionsTiposDeEquipamento = [
    { value: 1, label: "Módulo" },
    { value: 2, label: "Inversor" },
    { value: 3, label: "Outros" }
];

const optionsPossuiAFCI = [
    { value: 0, label: "Não informado" },
    { value: 1, label: "Sim" },
    { value: 2, label: "Não" },
];

const selectStyles = {
    control: (styles) => ({
        ...styles,
        marginTop: '15px',
        color: '#707070',
        backgroundColor: '#343434',
        borderRadius: "10px",
        padding: "3px"
    }),
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            backgroundColor: '#343434',
            color: '#707070',
            border: 'none',
        }
    },
    input: (styles) => ({ ...styles, color: "#707070" }),
    singleValue: (styles) => ({ ...styles, color: "#707070" }),
    menuList: (styles) => ({ ...styles, backgroundColor: "#343434" }),
}

const schema = yup.object().shape({
    descricao: yup.string().max(500, "Máximo de 500 caracteres").required("Este campo é obrigatório"),
    fabricante: yup.string().max(100, "Máximo de 100 caracteres")
        .when("fabricanteForaLista", {
            is: true,
            then: (schema) => schema.required("O campo fabricante é obrigatório"),
            otherwise: (schema) => schema.nullable(),
        }),
    fases: yup.object().shape({
        label: yup.string().required("requerido"),
        value: yup.string().required("requerido")
    }),
    tipo: yup.object().shape({
        label: yup.string().required("requerido"),
        value: yup.number().typeError("Este campo é obrigatório").required("Este campo é obrigatório")
    }),
    possuiafci: yup.object().shape({
        value: yup.number().nullable(),
        label: yup.string().nullable()
    }),
    dataCertificacao: yup.date().typeError("Valor inválido. Este campo é obrigatório").required("Este campo é obrigatório"),
    potencia: yup.number().typeError("Este campo é obrigatório").min(0, "O valor mínimo é zero.").required("Este campo é obrigatório"),
    tensaoFornecimento: yup.object().shape({
        value: yup.number().nullable(),
        label: yup.string().nullable()
    }),
    fabricanteCadastrado: yup
        .object()
        .shape({
            value: yup.string().nullable(),
            label: yup.string().nullable(),
        })
        .when("fabricanteForaLista", {
            is: false,
            then: (schema) =>
                schema.shape({
                    value: yup
                        .string()
                        .required("O campo fabricante é obrigatório"),
                    label: yup
                        .string()
                        .required("O campo fabricante é obrigatório"),
                }),
            otherwise: (schema) =>
                schema.shape({
                    value: yup.string().nullable(),
                    label: yup.string().nullable(),
                }),
        }),
    fabricanteForaLista: yup.boolean().default(false)
});

const Cadastro = ({ setOpenPopup, recordForEdit, addOrEdit, pesquisar, origemSolicitacao, origemListaEquipamentosSolicitacao = false }) => {
    const methods = useForm({ defaultValues: valoresIniciais, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);

    const [podeSalvar, setPodeSalvar] = useState(true);
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [disableUpload, setDisableUpload] = useState(false);
    const [disableCampos, setDisableCampos] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [fecharAoSalvar, setFecharAoSalvar, fecharAoSalvarRef] = useStateRef(true);

    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
    const { salvarNovoEquipamento } = useContext(EquipamentoContext);
    const { equipamentoFoiEditado, setEquipamentoFoiEditado } = useContext(EquipamentoContext);

    const [tensaotensaoFornecimento, setTensaoFornecimento] = useState(null);
    const [codigoTensaoFornec, setCodigoTensaoFornec] = useState(0);
    const [required, setRequired] = useState(false);
    const [situacao, setSituacao] = useState(0);
    const [fabricanteCadastrado, setFabricanteCadastrado] = useState(null);
    const [fabricanteForaLista, setFabricanteForaLista] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpen(false);
        }

        setOpen(false);
    }

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccess(false);
        }

        setOpenSuccess(false);
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }

    useEffect(() => {
        const situacoesBloqueadas = [1, 3, 4];

        if (recordForEdit !== null) {
            const recuperarDados = async () => {
                try {
                    setIsLoading(true);

                    let data = await servEquipamentos.RecuperarParaEditar(recordForEdit?.id || recordForEdit?.Id);

                    mapearCamposDaEdicao(data.Content);
                    setSituacao(data.Content.Situacao)

                    setIsLoading(false);

                } catch (err) {
                    setIsLoading(false);

                    if (err?.response?.status === 401) {
                        setErrorMessage("Token expirado, redirecionando...");
                        setOpen(true);
                        return setTimeout(() => {
                            dispatch(logout());
                            navigate("/");
                        }, [2000]);
                    }

                    setErrorMessage(err?.response?.data?.Message);
                    setOpen(true);
                }
            }

            recuperarDados();

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao)) {
                setPodeSalvar(false);
                setDisableUpload(true);
                setDisableCampos(true);
            }
        } else {
            const recuperarDocumentosIniciais = async () => {
                try {
                    setIsLoading(true);


                    let response = await servParam.RecuperarDocumentosObrigatorios(2);

                    setDocumentosObrigatorios(response.Content);

                    setIsLoading(false);

                } catch (err) {
                    setIsLoading(false);

                    if (err?.response?.status === 401) {
                        setErrorMessage("Token expirado, redirecionando...");
                        setOpen(true);
                        return setTimeout(() => {
                            dispatch(logout());
                            navigate("/");
                        }, [2000]);
                    }

                    setErrorMessage(err?.response?.data?.Message);
                    setOpen(true);
                }
            }

            const definirDataCertificacaoInicial = () => {
                let dataInicial = new Date();

                dataInicial.setHours(0);
                dataInicial.setMinutes(0);
                dataInicial.setSeconds(0);
                dataInicial.setMilliseconds(0);

                methods.setValue("dataCertificacao", dataInicial);
            }

            recuperarDocumentosIniciais();
            definirDataCertificacaoInicial();
        }
    }, [recordForEdit]);

    const handleClickOpenDialog = async (event, reason) => {
        try {
            setFecharAoSalvar(false);
            await handleCadastroEquipamentos();
            setFecharAoSalvar(true);

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            if (reason === 'clickaway') {
                setOpenDialog(true);
            }

            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const mapearCamposDaEdicao = (data) => {
        methods.setValue("Id", data.CodigoEquipamento);
        methods.setValue("descricao", data.Descricao);
        methods.setValue("fabricante", data?.Fabricante || "");
        methods.setValue("modelo", data.Modelo);
        methods.setValue("fases", {
            value: data.NumeroFases,
            label: options.find((option) => option.value == data.NumeroFases).label
        });
        
        const tipoOption = optionsTiposDeEquipamento.find(opt => opt.value == data.Tipo);

        methods.setValue("tipo", {
            value: data.Tipo,
            label: tipoOption ? tipoOption.label : "Tipo desconhecido"
        });

        methods.setValue("possuiafci", {
            value: data.PossuiAFCI,
            label: optionsPossuiAFCI.find((optionsPossuiAFCI) => optionsPossuiAFCI.value == data.PossuiAFCI).label
        });
        methods.setValue("dataCertificacao", parse(data.DataValidadeCertificacao, 'dd/MM/yyyy HH:mm:ss', new Date()));
        methods.setValue("potencia", data.PotenciaKw);
        methods.setValue("situacao", data.Situacao);

        if (data?.CodigoTensaoFornecimento) {
            setCodigoTensaoFornec(data?.CodigoTensaoFornecimento);
            setTensaoFornecimento({
                value: data?.CodigoTensaoFornecimento,
                label: `${data?.CodigoTensaoFornecimento} - ${data?.TensaoFornecimento?.Descricao}`
            });
            methods.setValue("tensaoFornecimento", {
                value: data.CodigoTensaoFornecimento,
                label: data?.TensaoFornecimento?.Descricao
            });
        }

        if (data?.CodigoFabricante) {
            setFabricanteCadastrado({
                value: data?.CodigoFabricante,
                label: `${data?.Fabricantes?.CodigoAneel} - ${data?.Fabricantes?.NomeFabricante}`
            });
            methods.setValue("fabricanteCadastrado", {
                value: data?.CodigoFabricante,
                label: `${data?.Fabricantes?.CodigoAneel} - ${data?.Fabricantes?.NomeFabricante}`
            });
        } else {
            setFabricanteForaLista(true);
            methods.setValue("fabricanteForaLista", true);
            methods.setValue("fabricante", data?.Fabricante || "");
            setFabricanteCadastrado({
                value: null,
                label: null
            });
        }

        let docs = data.ConfiguracaoDocs;

        docs.map((doc) => {
            if (data.EquipamentosVinculados.length) {
                for (let i = 0; i < data.EquipamentosVinculados.length; i++) {
                    if ((doc.Id == data.EquipamentosVinculados[i].CodigoConfiguracaoDoc) &&
                        (doc.CodigoClassificacaoDoc == data.EquipamentosVinculados[i].CodigoClassificacaoDoc)) {
                        doc.CodigoDocumento = data.EquipamentosVinculados[i].CodigoDocumento;
                        doc.NomeArquivo = data.EquipamentosVinculados[i].NomeArquivo;
                    }
                }
            }
        });

        setDocumentosObrigatorios(docs);
    };

    const verificarTensaoFornecimento = () => {
        let { value: tipoValue } = methods.getValues("tipo");
        let { value: tensaoValue } = methods.getValues("tensaoFornecimento");

        if (tipoValue === 2 && !tensaoValue) {
            setRequired(true);
        }
    }

    const handleCadastroEquipamentos = methods.handleSubmit(async (data) => {
        try {
            const nomeFabricante = data.fabricanteForaLista ? data.fabricante : data?.fabricanteCadastrado?.label.split('-')[1].split('|')[0].trim();
            
            const equipamento = {
                Id: data.Id,
                descricao: data.descricao,
                fabricante: nomeFabricante,
                modelo: data.modelo,
                fases: data.fases.value,
                tipo: data.tipo.value,
                possuiafci: data.possuiafci.value,
                codigoUsuario: user.codigoUsuario,
                dataCertificacao: data.dataCertificacao,
                potencia: data.potencia,
                codigoTensaoFornecimento: data?.tensaoFornecimento?.value,
                codigoFabricante: data?.fabricanteCadastrado?.value
            }

            if (equipamento.tipo === 2 && !equipamento.codigoTensaoFornecimento) {
                setRequired(true);
                return;
            }

            setIsLoading(true);

            let codigoEquipamento = await adicionarOuEditar(equipamento);
            methods.setValue("Id", codigoEquipamento);
            methods.reset({}, { keepValues: true });

            // Verifica se equipamento veio do orçamento de conexão e se o cadastro deve ser fechado ou não ao salvar
            if (origemSolicitacao && fecharAoSalvarRef.current) {
                // Verifica se o equipamento veio ao clicar na lupa na lista de equipamentos do orçamento de conexão
                if (!origemListaEquipamentosSolicitacao) {
                    salvarNovoEquipamento(codigoEquipamento, equipamento);
                }

                if (origemListaEquipamentosSolicitacao) {
                    setEquipamentoFoiEditado(true);
                }

                setOpenPopup(false);
                setIsLoading(false);
                return;
            }

            setIsLoading(false);

            setOpenSuccess(true);
            setSuccessMessage("Equipamento salvo com sucesso.");

            if (fecharAoSalvarRef.current) {
                setTimeout(() => {
                    setOpenPopup(false);
                }, [1000]);
            }

            if (!origemSolicitacao) {
                pesquisar();
            }
        } catch (err) {
            setIsLoading(false);
            setOpen(true);
            return setErrorMessage(err?.response?.data?.Message);
        }
    });

    const adicionarOuEditar = async (equipamento) => {
        let id;
        if (equipamento.Id == 0) {
            const response = await servEquipamentos.inserir(
                equipamento.descricao,
                equipamento.fabricante,
                equipamento.modelo,
                equipamento.fases,
                equipamento.tipo,
                equipamento.possuiafci,
                equipamento.codigoUsuario,
                equipamento.dataCertificacao,
                equipamento.potencia,
                equipamento.codigoTensaoFornecimento,
                equipamento.codigoFabricante
            );

            id = response.Content.Id;
        } else {
            const response = await servEquipamentos.editar(
                equipamento.Id,
                equipamento.descricao,
                equipamento.fabricante,
                equipamento.modelo,
                equipamento.fases,
                equipamento.tipo,
                equipamento.possuiafci,
                equipamento.codigoUsuario,
                equipamento.dataCertificacao,
                equipamento.potencia,
                equipamento.codigoTensaoFornecimento,
                equipamento.codigoFabricante
            )

            id = response.Content.Id;
        }

        return id;
    }

    const handleTabChange = async (event, newValue) => {
        const situacoesNaoEditaveis = [1, 3, 4];
        let tensaoFornecimento = methods.getValues("tensaoFornecimento");
        let tipo = methods.getValues("tipo");

        if (situacoesNaoEditaveis.includes(methods.getValues("situacao"))) {
            setTabIndex(newValue);
            return;
        }

        if (tipo.value === 2 && !tensaoFornecimento.value) {
            setRequired(true);
            return;
        }

        if (methods.getValues("Id") == 0) {
            setFecharAoSalvar(false);
            await handleCadastroEquipamentos();
            setFecharAoSalvar(true);

            if (Object.keys(methods.formState.errors).length > 0) {
                verificarTensaoFornecimento();
                return;
            }

            setTabIndex(newValue);
        } else {
            let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

            if (houveAlteracaoCampos) {
                setFecharAoSalvar(false)
                await handleCadastroEquipamentos();
                setFecharAoSalvar(true);

                if (Object.keys(methods.formState.errors).length > 0) {
                    return;
                }
            }

            setTabIndex(newValue);
        }
    }

    const solicitarHomologacao = async () => {
        try {
            setIsLoading(true);

            await servEquipamentos.SolicitarHomologacao(methods.getValues("Id"));

            setOpenSuccess(true);
            setSuccessMessage("Solicitação de homologação enviada com sucesso.");
            setIsLoading(false);

            setOpenDialog(false);

            // Verifica se o equipamento vem diretamente do orçamento de conexão,
            // se for, ele não faz as funcionalidades do salvar padrão.
            // Ele realiza ações para que o equipamento seja setado no searchfield de equipamentos do orçamento de conexão.
            if (origemSolicitacao) {
                if (!origemListaEquipamentosSolicitacao) {
                    const equipamento = {
                        Id: methods.getValues("Id"),
                        descricao: methods.getValues("descricao"),
                        fabricante: methods.getValues("fabricante"),
                        modelo: methods.getValues("modelo"),
                        fases: methods.getValues("fases"),
                        tipo: methods.getValues("tipo"),
                        possuiafci: methods.getValues("possuiafci"),
                        potencia: methods.getValues("potencia")
                    };

                    salvarNovoEquipamento(equipamento.Id, equipamento);
                }

                // Verifica se o equipamento foi editado diretamente da lista de equipamentos dentro do orçamento de conexão.
                // Se for, se seta uma propriedade que está definida no useEffect do componente de searchfield. Listando
                // os equipamentos novamente, com as novas situações ou dados editados.
                if (origemListaEquipamentosSolicitacao) {
                    setEquipamentoFoiEditado(true);
                }

                setTimeout(() => {
                    setOpenPopup(false);
                }, [1400]);

                return;
            }

            setTimeout(() => {
                setOpenPopup(false);
                pesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setErrorMessage(err?.response?.data?.Message);
            return setOpen(true);
        }
    }

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <FormProvider {...methods}>
                <form onSubmit={handleCadastroEquipamentos}>
                    <div className={styles.class100E}>
                        <div className={styles.tabsEHeader}>
                            <Tabs value={tabIndex} sx={{ width: "95%" }} onChange={handleTabChange} aria-label="abas cadastro de equipamentos">
                                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                                <Tab sx={{ color: "whitesmoke" }} label="Documentos" {...a11yProps(1)} />
                            </Tabs>
                        </div>
                        <TabPanel value={tabIndex} index={0}>
                            <Geral
                                disableCampos={disableCampos}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                setTensaoFornecimento={setTensaoFornecimento}
                                setCodigoTensaoFornec={setCodigoTensaoFornec}
                                tensaotensaoFornecimento={tensaotensaoFornecimento}
                                tipoEquipamento={methods.getValues("tipo").value}
                                required={required}
                                setRequired={setRequired}
                                recordForEdit={recordForEdit}
                                situacao={situacao}
                                setFabricanteCadastrado={setFabricanteCadastrado}
                                fabricanteCadastrado={fabricanteCadastrado}
                                fabricanteForaLista={fabricanteForaLista}
                                setFabricanteForaLista={setFabricanteForaLista}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Documentos
                                disableUpload={disableUpload}
                                documentos={documentosObrigatorios}
                                setErrorMessage={setErrorMessage}
                                setIsLoading={setIsLoading}
                                setOpen={setOpen}
                                addOrEdit={addOrEdit}
                                tipoEquipamento={methods.getValues("tipo").value}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles.cadastro_equipamentos_botoes}>
                        <BlueHoverButton type="submit" id="salvarEquipamento" name="salvarEquipamento" disabled={!podeSalvar}>
                            Salvar
                        </BlueHoverButton>
                        {tabIndex == 1 && (
                            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                                Solicitar homologação
                            </BlueHoverButton>
                        )}
                        <BlueHoverButton onClick={() => setOpenPopup(false)}>
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>
            <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                    {successMessage}
                </Alert>
            </Snackbar>
            <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
                    {"Solicitar homologação"}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
                        Você deseja enviar o equipamento para homologação?
                        Após o envio, o equipamento só poderá ser alterado em uma eventual reprovação.

                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: "#232323" }}>
                    <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    <BlueHoverButton autoFocus onClick={solicitarHomologacao}>
                        Continuar
                    </BlueHoverButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export { Cadastro }
